import angular from 'angular'

import { authRun } from './auth.run'
import { authRoutes } from './auth.routes'
import { authService } from './services/auth.service'
import { strongPasswordService } from './services/strong-password.service'

import { strongPasswordTooltip } from './directives/strong-password-tooltip/strong-password-tooltip.directive'
import { strongPasswordStrengthBar } from './directives/password-strength-bar/password-strength-bar.directive'

const module = angular
  .module('deskfy.auth', [])
  .config(authRoutes)
  .run(authRun)
  .factory('AuthService', authService)
  .factory('StrongPasswordService', strongPasswordService)
  .directive('strongPasswordTooltip', strongPasswordTooltip)
  .directive('strongPasswordStrengthBar', strongPasswordStrengthBar)

export const authModule = module
